export type Suggestion = {
  term: string
  popularity: number
  type: string
  metadata: {
    index: number
    image_url?: string
    image_base64?: string
  }
}

export type SuggestionsResponse = {
  type: string
  suggestions: Suggestion[]
  image_suggestions?: Suggestion[]
}

export enum DeleteSuggestions {
  Recent = 'recent',
  Popular = 'popular',
  All = 'all',
}

export type SearchEngagement = {
  fragment: string
  suggestion: string
}

export type SearchSuggestions = {
  fragment: string
  related_only: boolean
}

export type DeleteSuggestionPayload = {
  type: string
  suggestions: string[]
}
